import * as actions from './stationSearchActionsConstants';

const initialState = {
  stations: [],
  suggested_stations: [],
  with_scheduled_service_stations: [],
  query: '',
  loading: false,
  error: null,
  suggested: {
    popular: [],
    suggested: []
  },
  recent: []
};


export default function(state = initialState, action) {
  switch(action.type) {
    case actions.STATION_SEARCH_REQUEST:
      return {
        ...state,
        loading: true,
        query: action.query,
        query_performed: false,
        error: false
      };
    case actions.STATION_SEARCH_ERROR:
      return {
        ...state,
        loading: false,
        error: true
      };
    case actions.STATION_SEARCH_SUCCESS:
      return {
        ...state,
        stations: action.stations['all'],
        suggested_stations: action.stations['suggested'] || [],
        with_scheduled_service_stations: action.stations['with_scheduled_service'],
        query_performed: true,
        has_matches: (
          (action.stations['all'] && action.stations['all'].length) || 
          (action.stations['suggested'] && action.stations['suggested'].length) ||
          (action.stations['with_scheduled_service'] && action.stations['with_scheduled_service'].length)
        ),
        loading: false,
        error: false
      };
    case actions.STATION_SEARCH_CLEAR:
      return {
        ...state,
        query: '',
        stations: [],
        suggested_stations: [],
        with_scheduled_service_stations: [],
        query_performed: false,
        loading: false,
        error: false
      };
    case actions.LOAD_SUGGESTED_STATIONS_SUCCESS:
      return {
        ...state,
        suggested: action.data
      };
    case actions.LOAD_RECENT_STATIONS_SUCCESS:
      return {
        ...state,
        recent: action.data
      };
    default:
      return state;
  }
}
